var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "v-main",
    [
      _c(
        "v-container",
        { staticClass: "fill-height", attrs: { fluid: "" } },
        [
          _c(
            "v-row",
            { attrs: { align: "center", justify: "center" } },
            [
              _c(
                "v-col",
                { attrs: { cols: "12", sm: "8", md: "4" } },
                [
                  _c(
                    "v-card",
                    { staticClass: "pa-6", attrs: { elevation: "2" } },
                    [
                      _c(
                        "v-card-title",
                        { staticClass: "justify-center" },
                        [
                          _c("v-img", {
                            staticClass: "mb-2",
                            attrs: {
                              src: "/img/sysclass_logo.png",
                              contain: "",
                              "max-width": "150",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "v-card-text",
                        [
                          _c("p", { staticClass: "text-center mb-6" }, [
                            _vm._v("Faça login e acesse sua conta do Sysclass"),
                          ]),
                          _c("FormsTextField", {
                            attrs: {
                              label: "E-mail",
                              "error-messages": _setup.errors.email,
                              outlined: "",
                              dense: "",
                              required: "",
                              type: "email",
                              autofocus: !_setup.requiredPassword,
                              disabled: _setup.loading,
                            },
                            on: {
                              "keyup-enter": function ($event) {
                                return _setup.sendEmail()
                              },
                            },
                            model: {
                              value: _setup.email,
                              callback: function ($$v) {
                                _setup.email = $$v
                              },
                              expression: "email",
                            },
                          }),
                          _c("v-checkbox", {
                            staticClass: "mt-2",
                            attrs: {
                              label: "Lembrar meu e-mail",
                              dense: "",
                              color: "primary",
                              disabled: _setup.loading,
                            },
                            model: {
                              value: _setup.rememberEmail,
                              callback: function ($$v) {
                                _setup.rememberEmail = $$v
                              },
                              expression: "rememberEmail",
                            },
                          }),
                          _setup.requiredPassword
                            ? _c("forms-text-field", {
                                staticClass: "mt-4",
                                attrs: {
                                  label: "Senha",
                                  outlined: "",
                                  dense: "",
                                  required: "",
                                  type: _setup.showPassword
                                    ? "text"
                                    : "password",
                                  disabled: _setup.loading,
                                  autofocus: _setup.requiredPassword,
                                },
                                on: {
                                  "keyup-enter": function ($event) {
                                    return _setup.login()
                                  },
                                },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "append",
                                      fn: function () {
                                        return [
                                          _c(
                                            "v-icon",
                                            {
                                              on: {
                                                click: function ($event) {
                                                  $event.stopPropagation()
                                                  _setup.showPassword =
                                                    !_setup.showPassword
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                _vm._s(
                                                  _setup.showPassword
                                                    ? "mdi-eye"
                                                    : "mdi-eye-off"
                                                )
                                              ),
                                            ]
                                          ),
                                        ]
                                      },
                                      proxy: true,
                                    },
                                  ],
                                  null,
                                  false,
                                  2427676210
                                ),
                                model: {
                                  value: _setup.password,
                                  callback: function ($$v) {
                                    _setup.password = $$v
                                  },
                                  expression: "password",
                                },
                              })
                            : _vm._e(),
                          _setup.requiredPassword
                            ? _c(
                                "div",
                                { staticClass: "justify-end d-flex" },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      staticClass: "mt-2",
                                      attrs: {
                                        small: "",
                                        text: "",
                                        color: "primary",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _setup.resetPassword()
                                        },
                                      },
                                    },
                                    [_vm._v("Esqueceu sua senha?")]
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                          _setup.message
                            ? _c(
                                "v-alert",
                                {
                                  staticClass:
                                    "mt-4 orange--text text--darken-1",
                                  attrs: {
                                    color: "orange lighten-4",
                                    dark: "",
                                    icon: "mdi-alert-circle",
                                    border: "left",
                                    prominent: "",
                                    outlined: "",
                                  },
                                },
                                [_vm._v(" " + _vm._s(_setup.message) + " ")]
                              )
                            : _vm._e(),
                          _setup.requiredPassword
                            ? _c("ButtonsDefault", {
                                staticClass: "mt-4",
                                attrs: {
                                  label: "Entrar",
                                  color: "primary",
                                  block: "",
                                  loading: _setup.loading,
                                  disabled: _setup.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.login()
                                  },
                                },
                              })
                            : _vm._e(),
                          !_setup.requiredPassword
                            ? _c("ButtonsDefault", {
                                staticClass: "mt-4",
                                attrs: {
                                  label: "Avançar",
                                  color: "primary",
                                  block: "",
                                  loading: _setup.loading,
                                  disabled: _setup.loading,
                                },
                                on: {
                                  click: function ($event) {
                                    return _setup.sendEmail()
                                  },
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _c(
                        "v-card-actions",
                        { staticClass: "justify-end" },
                        [
                          _c(
                            "v-btn",
                            {
                              staticClass: "mr-1 mb-1",
                              attrs: { small: "", text: "", color: "teal" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _setup.toAccessTeacher()
                                },
                              },
                            },
                            [
                              _vm._v("Sou Professor "),
                              _c("v-icon", { attrs: { right: "" } }, [
                                _vm._v("mdi-school-outline"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "d-flex justify-end mt-2 pr-2" },
                    _vm._l(_setup.links, function (link) {
                      return _c(
                        "v-btn",
                        {
                          key: link.icon,
                          attrs: {
                            href: link.url,
                            color: link.color,
                            target: "_blank",
                            icon: "",
                          },
                        },
                        [_c("v-icon", [_vm._v(_vm._s(link.icon))])],
                        1
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }